// extracted by mini-css-extract-plugin
export default {"backButton":"back-button_backButton__1pCM1"};